import styled from "styled-components";

interface IBottonCommon {
  backgroundColor?: string;
  border?: string;
  borderRadius?: string;
  borderWidth?: string;
  color?: string;
  fontSize?: string;
  height?: string;
  marginBottom?: string;
  marginLeft?: string;
  marginTop?: string;
  placeholder?: string;
  width?: string;
}
export const BottonCommon = styled.button<IBottonCommon>`
  ${(props) => `
      font-family: ${props.theme.fontFamilies.primaryFont};
      background-color: ${
        props.backgroundColor ? props.backgroundColor : "#002E6C"
      };
      border: ${props.border ? props.border : "none"};
      border-width: ${props.borderWidth ? props.borderWidth : "none"};
      border-radius: ${props.borderRadius ? props.borderRadius : "8px"};
      color: ${props.color ? props.color : "#FFFFFF"};
      height: ${props.height ? props.height : "5rem"};
      margin-left: ${props.marginLeft ? props.marginLeft : "0rem"};
      margin-top: ${props.marginTop ? props.marginTop : "0rem"};
      width: ${props.width ? props.width : "100%"};
      box-shadow: 0px 10px 20px #F4F4F4;
  `}
  align-items: center;
  cursor: pointer;
  display: flex;
  font-size: 1.5rem;
  font-weight: 700;
  justify-content: center;
  :disabled,
  [disabled] {
    background-color: ${(props) =>
      props.backgroundColor + props.theme.transparencies.p58};
    cursor: not-allowed;
  }
`;
